<!--
  * name: Srch
  * description: [Main] Srch 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="제품검색"></bread-crumb>
    <!-- 병헌 : 경로 -->
    <top-area
      :searchWord="searchWord"
      @search-data="searchData"
      :recommendedProduct="recommendedProduct"
    />
    <!-- 제목 및 검색 인풋 영역 -->
    <result :searchWord="searchWord" :searchedProducts="searchedProducts" />
    <!-- 결과 영역 -->
  </div>
</template>

<script>
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
// import PageTitle from '@/components/page/PageTitle.vue';
import productsList from '@/utils/productsList';
import { mapGetters } from 'vuex';
import productApi from '@/apis/product';
import TopArea from './partial/TopArea.vue';
import Result from './partial/Result.vue';

export default {
  name: 'Srch',
  components: {
    BreadCrumb,
    // PageTitle,
    TopArea,
    Result,
  },
  data() {
    return {
      searcheWord: '',
      searchedProducts: [],
      recommendedProduct: [],
    };
  },
  computed: {
    ...mapGetters({
      searchedData: 'search/getSearchedData',
    }),
  },
  watch: {
    searchData() {
      this.searchWord = this.searchData.searchedName;
    },
  },
  created() {
    this.searchWord = this.searchedData.searchedName;
    this.filterProductsList();
    this.recommendedProduct = productsList.RECOMMENDED_PRODUCTS;
  },
  methods: {
    searchData(input) {
      this.searchWord = input;
      this.filterProductsList();
    },
    async filterProductsList() {
      this.searchedProducts = await productApi.getProducts(encodeURIComponent(this.searchWord));
    },
  },
};
</script>
